import LandingPage from 'src/features/LandingPage';

// Purchasing group page for Veterinaro customers, built from the landing page sections
const Veterinaro = () => <LandingPage page='veterinaro' />;

export default Veterinaro;
